module.exports = __webpack_public_path__ + "img/scandcqindex.8484e1e2.jpg";